import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 px-4" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative p-8 md:p-12 rounded-3xl border border-white/10 bg-gradient-to-b from-white/5 to-transparent overflow-hidden text-center" data-id="element-36">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-[#0ea5e9] to-transparent opacity-50" data-id="element-37" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/5 border border-white/10 mb-8 relative" data-id="element-38">
            <div className="absolute inset-0 rounded-full box-glow opacity-50" data-id="element-39" />
            <ShieldIcon className="w-10 h-10 text-[#00d4ff]" data-id="element-40" />
          </div>

          <h2 className="text-3xl font-bold mb-6" data-id="element-41">
            La Garantía de "Cero Riesgo" de 7 Días
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-42">
            Si aplicas los protocolos por una semana y no sientes una claridad
            mental que no tenías hace años, envíanos un email.{' '}
            <strong className="text-white" data-id="element-43">
              Te devolvemos el 100% de tu dinero y te quedas con los libros.
            </strong>{' '}
            Así de seguros estamos de que esto funciona.
          </p>
        </motion.div>
      </div>
    </section>;
}